import { render } from "./AccessGate.vue?vue&type=template&id=22b9a0bd&scoped=true"
import script from "./AccessGate.vue?vue&type=script&lang=js"
export * from "./AccessGate.vue?vue&type=script&lang=js"

import "./AccessGate.vue?vue&type=style&index=0&id=22b9a0bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b9a0bd"]])

export default __exports__